import React from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Input,
  Button,
  FormFeedback,
} from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//i18n
import { withTranslation } from "react-i18next"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

import Snackbars from "../../Utils/Snackbars"
import useRequests from "../../Utils/useRequests"

const MailChimp = props => {
  //meta title
  document.title = "Sync with Mailchimp"
  const { getRequest, postRequest } = useRequests()
  const [totalUsers, setTotalUsers] = React.useState(0)
  const [syncUsers, setSyncUsers] = React.useState(0)
  const [recentlySyncUsers, setRecentlySyncUsers] = React.useState(0)
  const [isSubmitting, setIsSubmitting] = React.useState(false) 

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  })
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "",
        message: "",
      }))
    }, 5000)
  }

  const handleSubmit = async () => {
    setIsSubmitting(true);

    const res = await getRequest("users-sync-mailchimp")

    if (res && res.code === 200) {
      let originalText = res.data
      
      setRecentlySyncUsers(originalText)
      setSyncUsers(syncUsers+originalText)

      setAlertData(AlertData => ({
        ...AlertData,
        variant: "success",
        message: res.message,
      }))
    } else {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: res.message,
      }))
    }
    setIsSubmitting(false)
    resetAlertData()
  }

  const handleLoadGetSiteSettings = async () => {
    const res = await getRequest("get-users")
    if (res && res.code === 200) {
      let originalText = res.data

      let sync_users = 0
      originalText.forEach(element => {
        if (element.subscribe_mailchimp == 1) {
          sync_users = sync_users + 1
        }
      })

      setTotalUsers(originalText.length)
      setSyncUsers(sync_users)
    } else {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: res.message,
      }))
    }
    resetAlertData()
  }

  React.useEffect(() => {
    handleLoadGetSiteSettings()
  }, [])

  return (
    <React.Fragment>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Tokenizedgreen")}
            breadcrumbItem={props.t("Mailchimp Data Sync")}
          />

          <Row>
            <Col lg="12">
              <form>
                <Row>
                  <Col md={12} xs="12">
                    <Card>
                      <CardBody>
                        <Row>
                          <Col md={12} xs={12}>
                            <Label className="form-label">
                              Total Users in System : {totalUsers}
                            </Label>
                          </Col>
                          <Col md={12} xs={12}>
                            <Label className="form-label">
                              Total Users in Mailchimp : {syncUsers}
                            </Label>
                          </Col>
                          <Col md={12} xs={12}>
                            <Label className="form-label">
                              Recently Synced Users : {recentlySyncUsers}
                            </Label>
                          </Col>
                          <Col md={6} xs={12}>
                            <Label className="form-label">
                            <br />
                              To sync our data with Mailchimp, please click the
                              button below.
                            </Label>
                          </Col>
                        </Row>
                        <div className="text-left">
                        <br />
                          <Button
                            type="button"
                            color="primary"
                            id="submit1"
                            onClick={e => {
                              e.preventDefault()
                              handleSubmit()
                              return false
                            }}
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? "Syncing..." : "Sync with Mailchimp"}
                          </Button>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </form>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(MailChimp)
